<script>
  /**
   * Write-only secret input.
   *
   * Never pre-filled and never shows the stored value — the server does not
   * send it. `status` is the server's `{ set, last4 }` view; an empty input
   * means "keep what is stored". The parent reads `value` and sends it only
   * when non-blank.
   */
  let {
    id,
    label,
    status = null,
    value = $bindable(''),
    placeholder = '',
    required = false,
  } = $props();

  const hint = $derived(
    status?.set
      ? `Set${status.last4 ? ` · ••••${status.last4}` : ''}${status.readable === false ? ' · cannot be decrypted' : ''}`
      : 'Not set'
  );
</script>

<div>
  <label for={id} class="text-xs font-medium p-muted">
    {label}
    <span class="ml-1 p-faint" data-testid="secret-hint">({hint})</span>
  </label>
  <input {id} class="p-input mt-1" type="password" autocomplete="new-password"
         bind:value
         required={required && !status?.set}
         placeholder={status?.set ? 'Leave blank to keep the stored value' : placeholder} />
</div>
